import RawOutput    from '../Domain/Code/Outputs/Contexts/RawOutput';
import Hex          from '../Domain/Code/Outputs/Formats/Hex';
import ColorPreview from '../Domain/Code/Outputs/Options/ColorPreview';

export default {
    namespaced: true,

    state: {
        outputter: null,
        context: RawOutput,
        format: Hex,
        options: {lineOptions: [ColorPreview], formatOptions: [], contextOptions: []},
    },

    mutations: {
        setContext(state, payload) {
            state.context = payload;
        },
        setFormat(state, payload) {
            state.format = payload;
        },
        setOptions(state, {type, options}) {
            state.options[type] = options;
        },
        setOutputter(state, payload) {
            state.outputter = payload;
        }
    },


}

